import { ThemeProvider } from 'styled-components';

import GlobalStyles from 'styles/GlobalStyles';

import Router from './Router';
import { theme } from './styles/theme';
import React from 'react';
import useModal from 'libs/hook/useModal';

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Provider>
          <Router />
        </Provider>
      </ThemeProvider>
    </div>
  );
}

const Provider = ({children}: {children?: React.ReactNode}) => {
  const modal = useModal();
  return <>
    {children}
    {modal.modal}
  </>
}

export default App;
